import React from 'react'
import Header from './Header'
import { Link } from 'react-router-dom'


export default function PrivacyPolicy() {
    return (
        <>
            <Header />
            <div className="about">
                <div style={{ marginTop: "100px" }} className="container">
                    <div className="row">
                        <div className="col-md-12 col-12 mt-2 heading">
                            <img src="images/leaf.png" alt="" />
                            <h2>Privacy Policy</h2>
                            <h3>Brahma Darshan Yoga</h3>
                        </div>
                    </div>
                
                  <div className="row mb-5">
                        <div className="col-12 col-lg-10 offset-lg-1 bg-white p-4 p-md-5 shadow-sm rounded" style={{ textAlign: 'left', lineHeight: '1.8', color: '#4a4a4a' }}>
                            
                            <p className="text-muted mb-4 border-bottom pb-3"><strong>Last Updated:</strong> {new Date().toLocaleDateString()}</p>

                            <h4 className="mt-4 mb-3 text-dark fw-bold">1. Introduction</h4>
                            <p>
                                Welcome to <strong>Brahma Darshan Yoga</strong>. This website is founded and managed by <strong>Abhay Kumar</strong>. 
                                We are committed to protecting your personal information and your right to privacy. 
                                This Privacy Policy applies to all information collected through our website, including our "Contact Us" form and our "Teacher Training Course Application" form.
                            </p>

                            <h4 className="mt-4 mb-3 text-dark fw-bold">2. Information We Collect</h4>
                            <p>
                                We collect personal information that you voluntarily provide to us when you inquire about our services or apply for a course. 
                                Based on the forms on our website, we collect the following specific data:
                            </p>
                            <ul className="list-group list-group-flush mb-3">
                                <li className="list-group-item bg-transparent">
                                    <strong>A. Through the "Contact Us" Form:</strong><br/>
                                    Identity Data (Full Name), Contact Data (Email ID and Phone Number), and any details you provide in the message box.
                                </li>
                                <li className="list-group-item bg-transparent">
                                    <strong>B. Through the "Teacher Training Course" Application Form:</strong>
                                    <ul className="mt-2">
                                        <li><strong>Identity Data:</strong> First Name, Last Name, Date of Birth, and Gender.</li>
                                        <li><strong>Contact Data:</strong> Email ID and Phone Number.</li>
                                        <li><strong>Location Data:</strong> Address details including City, State, Country, and Pincode/Zipcode.</li>
                                    </ul>
                                </li>
                            </ul>

                            <h4 className="mt-4 mb-3 text-dark fw-bold">3. How We Use Your Information</h4>
                            <p>We use the information we collect for specific purposes related to our yoga services:</p>
                            <ul>
                                <li><strong>To Process Applications:</strong> We use the detailed personal data (DOB, Gender, Address) submitted in the Application Form to register you for our 200, 300, 500, or 800-hour Teacher Training Courses and to verify your eligibility.</li>
                                <li><strong>To Respond to Inquiries:</strong> We use the basic contact details from the Contact Form to answer your questions about course dates, fees, and curriculum.</li>
                                <li><strong>Communication:</strong> To send you confirmation emails, course schedules, or updates regarding your application status.</li>
                            </ul>

                            <h4 className="mt-4 mb-3 text-dark fw-bold">4. Financial Information</h4>
                            <div className="alert alert-info border-0 bg-light text-dark">
                                <p className="mb-0">
                                    <strong>We do not collect online payments.</strong> Our website forms are strictly for applications and inquiries. 
                                    We do not store or collect credit card details, bank account numbers, or UPI IDs through this website. 
                                    All fee payments are handled offline or via external secure channels agreed upon after your application is approved.
                                </p>
                            </div>

                            <h4 className="mt-4 mb-3 text-dark fw-bold">5. Sharing Your Information</h4>
                            <p>
                                We respect your privacy. We do not sell, trade, or rent your personal identification information to third parties. 
                                Your data is used solely by <strong>Brahma Darshan Yoga</strong> for administrative and course management purposes.
                            </p>

                            <h4 className="mt-4 mb-3 text-dark fw-bold">6. Photography and Media (Course Policy)</h4>
                            <p>
                                Please be aware that while this digital policy covers your online data, our physical courses are group activities. 
                                We may take photographs or videos during the Teacher Training Courses for educational or promotional use (e.g., website gallery, social media).
                                If you are accepted into a course and wish to opt out of being photographed, please inform the administration in writing before the course begins.
                            </p>

                            <h4 className="mt-4 mb-3 text-dark fw-bold">7. Data Security</h4>
                            <p>
                                We implement appropriate data collection, storage, and processing practices to protect against unauthorized access or disclosure of your personal information 
                                (including your address and contact details) stored on our systems.
                            </p>

                            <h4 className="mt-4 mb-3 text-dark fw-bold">8. Contact Us</h4>
                            <p>
                                If you have any questions about this Privacy Policy or your application data, please contact us directly:
                            </p>
                            <div className="card bg-light border-0">
                                <div className="card-body">
                                    <p className="mb-1"><strong>Founder:</strong> Abhay Kumar</p>
                                    <p className="mb-1"><strong>Email:</strong> abhayinatural@gmail.com</p>
                                    <p className="mb-0"><strong>Phone:</strong> +918285038252</p>
                                </div>
                            </div>

                        </div>
                    </div>
                  
                </div>
            </div>
        </>
    )
}
